module.exports = __webpack_public_path__ + "static/media/menuTableros.169804fe.png";